import { AttachmentMetadata } from "@azure/communication-react";
import { Image } from "@fluentui/react";
import React from "react";

export const ImageAttachmentRenderer = (props: { attachment: AttachmentMetadata }) => {
    const { attachment } = props;

    return (
        <Image
            src={attachment.url}
            alt={attachment.name}
            styles={{
                root: {
                    overflow: 'visible',
                    width: 'fit-content'
                }, 
            }}
        />
    );
};
